module.exports = __webpack_public_path__ + "media/PAG82-07.ae611fa1.mp3";